import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M21.63 5.03a4.732 4.732 0 1 0-9.328 1.578L9.337 10.55l-1.467.512a4.3 4.3 0 0 0-2.002 1.396L3.17 16.023a3.154 3.154 0 0 0 .607 4.416.8.8 0 0 0 .591.15.8.8 0 0 0 .529-.3l3.808-5.03a.788.788 0 1 1 1.254.953l-3.816 5.032a.79.79 0 0 0 .157 1.104c.545.42 1.213.647 1.9.646q.222.012.442 0a3.16 3.16 0 0 0 2.082-1.222l2.673-3.54a4.3 4.3 0 0 0 .86-2.366l.063-1.578 2.941-3.88a4.73 4.73 0 0 0 3.454-1.852 4.73 4.73 0 0 0 .915-3.525m-8.673 8.478a.8.8 0 0 0-.158.441l-.079 1.79a2.66 2.66 0 0 1-.544 1.506l-2.673 3.541a1.58 1.58 0 0 1-1.041.615 2 2 0 0 1-.426 0l3.17-4.234a2.367 2.367 0 0 0-3.77-2.863l-3.2 4.235a1.58 1.58 0 0 1 .196-1.577l2.69-3.557a2.7 2.7 0 0 1 1.269-.914l1.687-.592a.74.74 0 0 0 .371-.268l2.547-3.36a4.7 4.7 0 0 0 2.452 1.885zm4.03-4.676a.7.7 0 0 0-.261 0 3.1 3.1 0 0 1-1.687-.631 3.194 3.194 0 1 1 1.947.623z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18.374 3.793a2.366 2.366 0 0 0-2.98 3.675c.436.376.993.58 1.569.575q.16.012.323 0a2.366 2.366 0 0 0 1.112-4.227zm-.788 2.365a.73.73 0 0 1-.52.308.8.8 0 0 1-.584-.15.79.79 0 0 1-.15-1.104c.119-.17.3-.286.504-.323h.11c.171 0 .337.055.474.157a.79.79 0 0 1 .15 1.104z"
    }, null, -1)
  ]))]))
}
export default { render: render }